import styled, { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';

export const TileWrapper = styled.div`
  background: ${(props) => props.theme.color.gray50};
  transition: background-color 0.25s ease-out;

  ${(props) =>
    props.isClickable &&
    !props.isJobTeaser &&
    css`
      cursor: pointer;
      &:hover {
        background: ${props.theme.teaserTile &&
        props.theme.teaserTile.hoverColor
          ? getColorByName(props.theme, props.theme.teaserTile.hoverColor)
          : props.theme.color.gray400} !important;
      }
    `};

  ${(props) =>
    props.isClickable &&
    props.isJobTeaser &&
    css`
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover::before {
        width: 120%;
        height: 180%;
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
      }
      & div {
        z-index: 1;
      }
      &::before {
        content: '';
        position: absolute;
        opacity: 0;
        width: 90%;
        height: 130%;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        background: ${props.theme.color.jobTeaserBackground ||
        props.theme.color.teaserTile};
        transition: all 0.35s cubic-bezier(0.71, -0.17, 0.53, 1.04);
        background-position: center;
        transform: translate(-50%, -50%) scale(0.8);
        z-index: 0;
      }
    `};
`;

/**
 * @param {TileProps} props
 * @returns {React.ReactElement} The rendered component
 */
export const Tile = ({
  isClickable = false,
  isJobTeaser = false,
  handleMouseEnter,
  handleMouseLeave,
  children,
  className,
  id = 'tile-wrapper',
}) => (
  <TileWrapper
    className={className}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    isClickable={isClickable}
    isJobTeaser={isJobTeaser}
    data-id="tile-wrapper"
    id={id}
  >
    {children}
  </TileWrapper>
);
